// services/purchases/TaxCreditPurchaseService.ts
import { taxCreditPurchaseApi } from '../../api';
import {
  TaxCreditProduct,
  TaxCreditProductUpdate,
} from '../../types/purchases/TaxCreditPurchase';

const TaxCreditPurchaseService = {
  /**
   * Agregar un producto a una compra con crédito fiscal
   * POST /api/tax-credit-purchases/products
   */
  addProduct: async (product: TaxCreditProduct) => {
    const response = await taxCreditPurchaseApi.addCustom('/products', product);
    return response.data;
  },

  /**
   * Actualizar un producto de una compra con crédito fiscal
   * PUT /api/tax-credit-purchases/products
   */
  updateProduct: async (product: TaxCreditProductUpdate) => {
    const response = await taxCreditPurchaseApi.modifyCustom('/products', product);
    return response.data;
  },

  /**
   * Eliminar un producto de una compra con crédito fiscal
   * DELETE /api/tax-credit-purchases/products/{detailId}
   */
  deleteProduct: async (detailId: number) => {
    const response = await taxCreditPurchaseApi.removeCustom(`/products/${detailId}`);
    return response.data;
  },

  /**
   * Obtener un producto para edición
   * GET /api/tax-credit-purchases/products/{detailId}
   */
  getProductById: async (detailId: number) => {
    const response = await taxCreditPurchaseApi.fetchCustom(`/products/${detailId}`);
    return response.data;
  },

  /**
   * Recalcular los totales (incluyendo IVA Percibido) de una compra ya
   * existente, sin modificar sus productos — útil cuando se corrige la
   * categoría de contribuyente del proveedor después de haber agregado
   * productos.
   * PUT /api/tax-credit-purchases/{purchaseId}/recalculate
   */
  recalculateTotals: async (purchaseId: number) => {
    const response = await taxCreditPurchaseApi.modifyCustom(`/${purchaseId}/recalculate`, {});
    return response.data;
  },

  /**
   * Sobrescribir manualmente el IVA Percibido de una compra ya existente
   * (caso de excepción no cubierto por la regla automática del 1%).
   * PUT /api/tax-credit-purchases/{purchaseId}/perceived-iva
   */
  updatePerceivedIVA: async (purchaseId: number, perceivedIVA: number) => {
    const response = await taxCreditPurchaseApi.modifyCustom(`/${purchaseId}/perceived-iva`, {
      perceivedIVA,
    });
    return response.data;
  },
};

export default TaxCreditPurchaseService;
